<template>
  <DefaultSection class="is-content">
    <Container>
      <div class="columns">
        <div
          v-for="block in blocks"
          :key="block?.id"
          class="column"
          :class="columnWith"
        >
          <template v-if="block">
            <h3 class="is-title is-size-banner has-text-weight-bold mb-4">
              {{ block.title }}
            </h3>
            <div
              class="has-text-weight-semibold is-size-normal"
              v-html="block.lead"
            />
            <div
              v-if="block.text"
              class="has-text-weight-medium is-size-normal content"
              v-html="block.text"
            />
            <VuepalLink
              v-if="block.link && block.link.url"
              :to="block.link.url.path"
              class="button is-normal is-sky-blue is-outlined has-text-weight-bold mt-5"
            >
              {{ block.link.title }}
            </VuepalLink>
          </template>
        </div>
      </div>
    </Container>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { ParagraphTextBlocksFragment } from '#graphql-operations'

const props = defineProps<ParagraphTextBlocksFragment>()

defineBlokkli({
  bundle: 'text_blocks',
  propsFieldMapping: {
    blocks: { type: 'field', name: 'field_blocks' },
  },
})

const columnWith = computed(() => {
  return `is-${12 / (props?.blocks?.length ?? 1)}`
})
</script>
